// extracted by mini-css-extract-plugin
export default {"creditsLink":"CreditsDialog_creditsLink__OTXKZ","creditsTitle":"CreditsDialog_creditsTitle__9eCsR"};